import { normalize } from 'polished';
import { createGlobalStyle, rem } from 'theme';

export const Normalized = createGlobalStyle`
  ${normalize()}

  p {
    margin: ${rem(16)} 0;
    font-family: var(--ref-font-family-opensans);
    font-weight: var(--ref-font-weight-200);
  }

  svg {
    display: inline;
  }
`;
